var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('hr',{staticClass:"mt-0"}),_c('RequiredAmountTable',{attrs:{"zoneSizesTotal":_vm.zoneSizesTotal,"additionalTotal":{
      heading: _vm.$t('Gesamtmenge'),
      amount: _vm.fertilizerAmountTotal,
      unit: 'kg',
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }